import { Controller } from "stimulus";
import toastr from 'toastr';
import $ from 'jquery';

export default class extends Controller {
  static targets = [ "step", "updateProfileModal" ]

  initialize() {
    this.index = 0
  }

  next(event) {
    event.preventDefault();
    const input = this.hiddenInputField(event.target.dataset.name, event.target.dataset.value)
    this.stepTargets[this.index].classList.add("hidden");
    this.index ++;
    this.stepTargets[this.index].classList.remove("hidden");
    document.querySelector("form#profile-modal").insertAdjacentHTML("beforeend", input)
  }

  submit(event) {
    const input = this.hiddenInputField(event.target.dataset.name, event.target.dataset.value)
    document.querySelector("form#profile-modal").insertAdjacentHTML("beforeend", input)
    $("form#profile-modal").submit(() => {
      this.updateProfileModalController.close();
      toastr.success("プロフィールの設定を変更しました！");
    })
  }

  hiddenInputField(name, value) {
    return `<input type="hidden" name="${name}" value="${value}">`;
  }

  get updateProfileModalController() {
    return this.application.getControllerForElementAndIdentifier(
      this.updateProfileModalTarget,
      "modal"
    );
  }
}
